import BaseRepository from '@/api/repositories/BaseRepository';

export default class DamageCasePaymentRepository extends BaseRepository {
	showPayment(damageCaseId, params = {}) {
		return this.get(`damageCase/${damageCaseId}/damageCasePayment`, params);
	}
}
